export const PLANS = [
  { value: 'trial', label: 'Proef' },
  { value: 'starter', label: 'Starter' },
  { value: 'growth', label: 'Growth' },
  { value: 'enterprise', label: 'Enterprise' },
]

export const SUB_STATUSES = [
  { value: 'trialing', label: 'Proefperiode' },
  { value: 'active', label: 'Actief' },
  { value: 'past_due', label: 'Achterstallig' },
  { value: 'cancelled', label: 'Opgezegd' },
]

export const ORG_STATUSES = [
  { value: 'active', label: 'Actief' },
  { value: 'suspended', label: 'Opgeschort' },
  { value: 'cancelled', label: 'Opgezegd' },
]

export function labelFor(options: { value: string; label: string }[], value: string): string {
  return options.find((o) => o.value === value)?.label ?? value
}

/** Long Dutch date, or a dash when nothing was recorded. */
export function formatSubscriptionDate(value: string | null): string {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}
